import * as Yup from 'yup';

// re-use the style used in covers/marine
const toOptionalNumber = (schema: Yup.NumberSchema<number | undefined>) =>
  schema.transform((val, orig) =>
    orig === '' || orig === null || typeof orig === 'undefined'
      ? undefined
      : val
  );

const requiredText = () => Yup.string().trim().required('Required');

const nonNegative = () =>
  toOptionalNumber(
    Yup.number().typeError('Invalid Number').min(0, 'Cannot be negative')
  );

export const propertyCoverRowSchema = () =>
  Yup.object({
    planCoverID: Yup.string().required('Required'),
    riskRate: nonNegative(),
    sumInsured: nonNegative(),
    premium: nonNegative()
  });

export const propertyRiskRowSchema = () =>
  Yup.object({
    riskDescription: requiredText(),
    geoLocation: requiredText(),
    location: Yup.string().trim().notRequired(),
    planCovers: Yup.array()
      .of(propertyCoverRowSchema())
      .min(1, 'At least one cover is required')
  });

export const propertyValidationSchema = () =>
  Yup.object({
    propertyRiskDetails: Yup.array()
      .of(propertyRiskRowSchema())
      .min(1, 'At least one risk is required')
  });
